import Items from './Items'

module.exports = Items.reducer( null, 'TIMER', 'projectId', [ 'projectId' ] )
